import { render } from "./UpdateUserComponent.vue?vue&type=template&id=3b3bc852&scoped=true"
import script from "./UpdateUserComponent.vue?vue&type=script&lang=js"
export * from "./UpdateUserComponent.vue?vue&type=script&lang=js"

import "./UpdateUserComponent.vue?vue&type=style&index=0&id=3b3bc852&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b3bc852"]])

export default __exports__